<script setup lang="ts">
// Placeholder for the Turnstile widget. Stays empty unless Cloudflare asks the
// visitor for an interaction (see useTurnstile).
const container = ref<HTMLElement | null>(null)

const { mount, unmount } = useTurnstile()

onMounted(() => {
  if (container.value) mount(container.value)
})

onBeforeUnmount(unmount)
</script>

<template>
  <div ref="container" data-testid="turnstile-widget" />
</template>
